// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"262":"13f55d4b","739":"fe7134dc"}[chunkId] + ".chunk.js";
};